module.exports = __webpack_public_path__ + "assets/img/title-download-note-8d9abd5b.png";